import { useFormik } from 'formik'
import React, { useEffect, useState } from 'react'
import { Col, Modal, Row, Spinner, Stack } from 'react-bootstrap'
import { createPortal } from 'react-dom'
import SVG from 'react-inlinesvg'
import * as Yup from 'yup'
import { defaultProductDetails } from './AddProductInterface'
import closeSymbol from '../../../../../_metronic/images/closeSymbol.svg'
import { useLazyQuery, useMutation, useQuery } from '@apollo/client'
import {
  GET_PRODUCT_DETAILS,
  CREATE_PRODUCT,
  GET_PRODUCT_BY_ID,
  UPDATE_PRODUCT,
  GET_ALL_SCRIPTS_LIST,
  GETCLIENTFEATUREFLAGS,
  GETLANGUAGE
} from '../../../../../utils/GraphQLAPI'
import moment from 'moment'
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import DatePicker from 'react-datepicker'
import 'react-datepicker/dist/react-datepicker.css'
import Dropdown from '../../../../sharedComponent/Dropdown/Dropdown'
import { alert, preventScroll, restrictDecimal, uploadFiles } from '../../../../../utils/helper'
import ElectricProperty from './AddProduct/ElectricProperty'
import './AddProduct/AddProduct.css'
import GasProperty from './AddProduct/GasProperty'
import AssingedSmartDocsSection from './AddSmartDocsSection'
import './SmartDocs.css'
import momentTimeZone from 'moment-timezone'

//validations
import {
  basicValidations,
  gasValidations,
  dynamicelectricValidations,
  electricValidations,
  dynamicgasValidations,
  MultiSelectOption,
  DocType,
  LanguageType
} from './AddProductUtils'
import DragDrop from '../../../../sharedComponent/UploadDrag'
import { PdfPreview } from '../../../../sharedComponent/Preview'
import ToggleButton from '../../../../sharedComponent/ToggleButton'
import { GLOBAL_CONSTANTS, POSITION_ID } from '../../../../../utils/GlobalConstants'

const fileUploadFileType = ['pdf']
const MySwal = withReactContent(Swal)

type Props = {
  show: boolean
  handleClose: () => void
  method: string
  editId: string
  refetchProduct: () => void
}
const noteList = [{ fieldName: 'note1', placeHolderText: 'Note 1' }]
const networkOnly = 'network-only'
const modalsRoot = document.getElementById('root-modals') || document.body

const AddProductModal = ({ show, handleClose, method, editId, refetchProduct }: Props) => {
  const [brandData, setBrandData] = useState<any>()
  const [commodityData, setCommodityData] = useState<any>()
  const [utilityData, setUtilityData] = useState<any>()
  const [contractTypeData, setContractTypeData] = useState<any>()
  const [customerTypeData, setCustomerTypeData] = useState<any>()
  const [unitData, setUnitData] = useState<any>()
  const [status, setStatus] = useState<string>('Add')
  const [tpvScript, setTpvScript] = useState<any>([])
  const [productType, setProductType] = useState('Standard')
  const [selectedEnglish, setEnglish] = useState<any>([])
  const [selectedSpanish, setSpanish] = useState<any>([])
  const [backendSmartDocs, setBackendSmartDocs] = useState<any[]>([]);
  const [documents, setDocuments] = useState<any>({})
  const [selectedDocs, setSelectedDocs] = useState<
    Record<LanguageType, Record<DocType, MultiSelectOption[]>>
  >({
    English: { tmc: [], dsc: [], other: [] },
    Spanish: { tmc: [], dsc: [], other: [] }
  });
  const [activeStatus, setActiveStatus] = useState<any>(true)
  const [isDynamicProducts, setisDynamicProducts] = useState(productType === 'Dynamic')
  const [expandedLang, setExpandedLang] = useState<string | null>('English');

  useEffect(() => {
    setisDynamicProducts(productType === 'Dynamic')
  }, [productType])

  const toggleLanguage = (lang: string) => {
    setExpandedLang(prev => (prev === lang ? null : lang));
  };

  const [validationSchema, setValidationSchema] = useState<any>({
    ...basicValidations,
    ...(isDynamicProducts ? dynamicelectricValidations : electricValidations),
  })
  const [commodity, setCommodity] = useState('Electric')
  const [submitting, setSubmitting] = useState(false)
  useEffect(() => {
    //to set corresponding validation based on the commodity
    if (commodity === 'Dual') {
      setValidationSchema({
        ...basicValidations,
        ...(isDynamicProducts ? dynamicelectricValidations : electricValidations),
        ...(isDynamicProducts ? dynamicgasValidations : gasValidations),
      })
    } else if (commodity === 'Electric') {
      setValidationSchema({
        ...basicValidations,
        ...(isDynamicProducts ? dynamicelectricValidations : electricValidations),
      })
    } else if (commodity === 'Gas') {
      setValidationSchema({
        ...basicValidations,
        ...(isDynamicProducts ? dynamicgasValidations : gasValidations),
      })
    }
  }, [commodity, isDynamicProducts])
  useEffect(() => {
    if (method === 'Create') {
      formik.setValues({ ...defaultProductDetails })
      setStatus('Add')
      setActiveStatus(true)
      setCommodity('Electric')
    } else if (method === 'edit' || method === 'clone') {
      getProductById()
      setStatus(method === 'edit' ? 'Edit' : 'Clone')
    }

    getClientFeatureFlags()
    getCustomerData()
    getAllScripts()
    formik.resetForm()
  }, [editId, method, show]) // eslint-disable-line react-hooks/exhaustive-deps
  //to get the feature flags from TPV admin
  const [getClientFeatureFlags, { data: featureFlags }] = useLazyQuery(GETCLIENTFEATUREFLAGS, {
    fetchPolicy: 'network-only',
  })

  const { data: Languages } = useQuery(GETLANGUAGE)

  //to get the product setup values to populate the dropdown
  const [getCustomerData] = useLazyQuery(GET_PRODUCT_DETAILS, {
    onCompleted: (data) => {
      setCommodityData(data?.getProductDetail[0]?.names)
      setUtilityData(data?.getProductDetail[1]?.names)
      setUnitData(data?.getProductDetail[2]?.names)
      setBrandData(data?.getProductDetail[3]?.names)
      setCustomerTypeData(data?.getProductDetail[4]?.names)
      setContractTypeData(data?.getProductDetail[5]?.names)
    },
    fetchPolicy: networkOnly,
  })

  const [getAllScripts] = useLazyQuery(GET_ALL_SCRIPTS_LIST, {
    fetchPolicy: networkOnly,
    variables: {
      getScriptsInput: {
        commodityId: null,
        isActive: true,
        languageId: null,
        salesChannelId: null,
        searchText: '',
        utilityId: null,
      },
    },
    onCompleted: (data) => {
      setTpvScript(data.getAllScripts.scripts)
    },
  })
  const [addProduct] = useMutation(CREATE_PRODUCT, {
    fetchPolicy: GLOBAL_CONSTANTS.networkOnlyMutation,
    onCompleted: () => {
      alert('Product added successfully', 'success')
      handleModalClose()
      refetchProduct()
      setCommodity('Electric')
      handleModalClose()
      setSubmitting(false)
    },
    onError: (e) => {
      alert(e.message, 'error')
      setSubmitting(false)
    },
  })

  const [updateProduct] = useMutation(UPDATE_PRODUCT, {
    fetchPolicy: networkOnly,
    onCompleted: (data) => {
      const options: any = {
        customClass: {
          popup: 'swal2-border-radius',
        },
        title: 'Product updated successfully',
        icon: 'success',
        confirmButtonColor: '#3E97FF',
      }
      MySwal.fire(options)
      refetchProduct()
      setCommodity('Electric')
      handleModalClose()
      setSubmitting(false)
    },
    onError: (e) => {
      alert(e.message, 'error')
      setSubmitting(false)
    },
  })
  //to set field value for dropdown
  const handleSelectedItem = (e: any, name: any) => {
    if (e.value.length > 0) {
      formik.setFieldValue(name, e.label)
      formik.setFieldValue(`${name}Id`, e.value)
    } else {
      formik.setFieldValue(name, '')
      formik.setFieldValue(`${name}Id`, null)
    }
  }
  useEffect(() => {
    if (!backendSmartDocs.length) return;
    if (!selectedEnglish.length && !selectedSpanish.length) return;

    const englishDocMap = new Map(
      selectedEnglish.map((doc: any) => [
        String(doc.value).trim(),
        doc.label,
      ])
    );

    const spanishDocMap = new Map(
      selectedSpanish.map((doc: any) => [
        String(doc.value).trim(),
        doc.label,
      ])
    );

    const updatedDocs: Record<LanguageType, Record<DocType, MultiSelectOption[]>> = {
      English: { tmc: [], dsc: [], other: [] },
      Spanish: { tmc: [], dsc: [], other: [] },
    };

    backendSmartDocs?.forEach((doc: any) => {
      const lang = doc?.language?.languageName as LanguageType;
      const type: DocType =
        doc.position === 0 ? 'tmc' :
          doc.position === 1 ? 'dsc' :
            'other';

      const key = String(doc.smartDocId).trim();

      const label =
        lang === 'English'
          ? englishDocMap.get(key)
          : spanishDocMap.get(key);

      if (typeof label !== 'string') return;

      updatedDocs[lang][type].push({
        value: key,
        label: label,
      });

    });

    setSelectedDocs(updatedDocs);
  }, [backendSmartDocs, selectedEnglish, selectedSpanish]);

  const [getProductById, { data: getProductByIdData, loading }] = useLazyQuery(GET_PRODUCT_BY_ID, {
    fetchPolicy: networkOnly,
    variables: {
      id: editId,
    },
    onCompleted: (productData) => {
      const editProductEnrollment = {
        id: productData.getProductById.id,
        productName: productData.getProductById.name || '',
        productCode: productData.getProductById.code || '',
        brand: productData.getProductById.brandType
          ? productData.getProductById.brandType.name
          : '',
        brandId: productData.getProductById.brandTypeId,
        productBrandId: productData.getProductById.brandType
          ? productData.getProductById.brandType.id
          : '',
        commodity: productData.getProductById.commodity
          ? productData.getProductById.commodity.name
          : '',
        commodityId: productData.getProductById.commodity
          ? productData.getProductById.commodity.id
          : '',
        ebillingMethod: Boolean(productData.getProductById.ebillingMethod)
          ? productData.getProductById.ebillingMethod
          : '',
        ecode: productData.getProductById.ecode ? productData.getProductById.ecode : '',
        utility: productData.getProductById.utility ? productData.getProductById.utility.name : '',
        utilityId: productData.getProductById.utility ? productData.getProductById.utility.id : '',
        contractType: productData.getProductById.contractType
          ? productData.getProductById.contractType.name
          : '',
        contractTypeId: productData.getProductById.contractType
          ? productData.getProductById.contractType.id
          : '',
        customerType: productData.getProductById.customerType
          ? productData.getProductById.customerType.name
          : '',
        customerTypeId: productData.getProductById.customerType
          ? productData.getProductById.customerType.id
          : '',
        unit: productData.getProductById.unit || '',
        unitId: productData.getProductById.unitTypeId || '',
        rate: String(productData.getProductById.rate) || '',
        secondRate: productData.getProductById.secondRate || '',
        term: productData.getProductById.term || '',
        rateMinimum: productData.getProductById.rateMinimum || '',
        rateMaximum: productData.getProductById.rateMaximum || '',
        termMinimum: productData.getProductById.termMinimum || '',
        termMaximum: productData.getProductById.termMaximum || '',
        earlyTerminationFee:
          productData.getProductById.earlyTerminationFee === null
            ? ''
            : productData.getProductById.earlyTerminationFee,
        serviceFee:
          productData.getProductById.serviceFee === null
            ? ''
            : productData.getProductById.serviceFee,
        added: productData.getProductById.adder === null ? '' : productData.getProductById.adder,
        language: '',
        script: productData.getProductById.script ? productData.getProductById.script.name : '',
        scriptId: productData.getProductById.script
          ? productData.getProductById.script.scriptId
          : '',
        prodScriptId: productData.getProductById.prodScriptId
          ? productData.getProductById.prodScriptId
          : '',
        deposit: productData.getProductById.deposit || '',
        gutility: productData.getProductById.gutility
          ? productData.getProductById.gutility.name
          : '',
        gutilityId: productData.getProductById.gutility
          ? productData.getProductById.gutility.id
          : '',
        gcontractType: productData.getProductById.gcontractType
          ? productData.getProductById.gcontractType.name
          : '',
        gcontractTypeId: productData.getProductById.gcontractType
          ? productData.getProductById.gcontractType.id
          : '',
        gunit: productData.getProductById.gunit || '',
        gunitId: productData.getProductById.gunitTypeId,
        grate: String(productData.getProductById.grate) || '',
        gsecondRate: productData.getProductById.gsecondRate || '',
        gterm: productData.getProductById.gterm || '',
        grateMinimum: productData.getProductById.grateMinimum || '',
        grateMaximum: productData.getProductById.grateMaximum || '',
        gtermMinimum: productData.getProductById.gtermMinimum || '',
        gtermMaximum: productData.getProductById.gtermMaximum || '',
        gearlyTerminationFee:
          productData.getProductById.gearlyTerminationFee === null
            ? ''
            : productData.getProductById.gearlyTerminationFee,
        gserviceFee:
          productData.getProductById.gserviceFee === null
            ? ''
            : productData.getProductById.gserviceFee,
        gadded: productData.getProductById.gadder === null ? '' : productData.getProductById.gadder,
        gdeposit: productData.getProductById.gdeposit || '',
        gbillingMethod: Boolean(productData.getProductById.gbillingMethod)
          ? productData.getProductById.gbillingMethod
          : '',
        gcode: productData.getProductById.gcode,
        startDate: Boolean(productData.getProductById.startDate)
          ? new Date(productData.getProductById.startDate)
          : null,
        endDate: Boolean(productData.getProductById.endDate)
          ? new Date(productData.getProductById.endDate)
          : null,
        note1: Boolean(productData.getProductById.notes) ? productData.getProductById.notes : null,
      }
      const productFiles = productData.getProductById?.productFiles || []

      const languageMap = new Map<string, string>(
        Languages?.getAllLanguages?.map((l: any) => [l.id as string, l.languageName as string])
      )

      const englishLanguageId = Languages?.getAllLanguages.find(
        (l: any) => l.languageName === 'English'
      )?.id

      const groupedDocs: any = {}
      productFiles.forEach((file: any) => {
        const finalLanguageId = file.languageId ?? englishLanguageId
        const languageName = languageMap.get(finalLanguageId)
        if (!languageName) return
        if (!groupedDocs[languageName]) {
          groupedDocs[languageName] = {}
        }
        switch (file.position) {
          case 0:
            groupedDocs[languageName].TC = file.fileUrl
            break
          case 1:
            groupedDocs[languageName].DSC = file.fileUrl
            break
          case 2:
            groupedDocs[languageName].OTHER = file.fileUrl
            break
        }
      })

      setDocuments(groupedDocs)

      setBackendSmartDocs(productData.getProductById.smartDocProducts || []);
      formik.setValues({ ...editProductEnrollment })
      productData.getProductById?.productType &&
        setCommodity(productData.getProductById?.productType)
      setActiveStatus(productData.getProductById.isActive ? true : false)
      setisDynamicProducts(productData.getProductById.isDynamicProduct)
      setProductType(productData.getProductById.isDynamicProduct ? 'Dynamic' : 'Standard')
    },
  })

  const formik: any = useFormik({
    initialValues: defaultProductDetails,
    validationSchema: Yup.object().shape(validationSchema),
    enableReinitialize: true,
    onSubmit: async (values) => {
      setSubmitting(true)
      let formData: any = {
        name: values.productName,
        brandTypeId: Boolean(values.brandId) ? values.brandId : null,
        isDynamicProduct: isDynamicProducts,
        commodityId:
          commodity === 'Electric'
            ? commodityData.filter((item: any) => item.value === 'Electric')[0]?.id
            : formik.getFieldMeta('commodityId').value,

        customerTypeId: formik.getFieldMeta('customerTypeId').value || null,
        description: '',
        //languageId : formik.getFieldMeta('languageId').value,
        isActive: activeStatus,
        productType: commodity.toUpperCase(),
        ...(values.startDate
          ? { startDate: moment.utc(values.startDate).format() }
          : { startDate: null }),
        ...(values.endDate ? { endDate: moment.utc(values.endDate).format() } : { endDate: null }),
      }
      if (commodity === 'Electric') {
        formData = {
          ...formData,
          unitTypeId: formik.getFieldMeta('unitId').value || null,
          contractTypeId: formik.getFieldMeta('contractTypeId').value || null,
          deposit: !Boolean(values.deposit) ? null : Number(values.deposit),
          earlyTerminationFee: !Boolean(values.earlyTerminationFee)
            ? null
            : Number(values.earlyTerminationFee),
          adder: values.added === '' ? null : Number(values.added),
          rate: values.rate ? Number(values.rate) : null,
          secondRate: !Boolean(values.secondRate) ? null : Number(values.secondRate),
          serviceFee: !Boolean(values.serviceFee) ? null : Number(values.serviceFee),
          term: values.term ? values.term : '',
          unit: values.unit ? values.unit : '',
          utilityId: formik.getFieldMeta('utilityId').value,
          ecode: values.ecode ? values.ecode : '',
          ebillingMethod: values.ebillingMethod ? values.ebillingMethod : '',
          dynamicProductInput: {
            rateMaximum: values.rateMaximum ? Number(values.rateMaximum) : null,
            rateMinimum: values.rateMinimum ? Number(values.rateMinimum) : null,
            termMinimum: values.termMinimum ? values.termMinimum : '',
            termMaximum: values.termMaximum ? values.termMaximum : '',
          },
        }
      } else if (commodity === 'Gas') {
        formData = {
          ...formData,
          gdeposit: !Boolean(values.gdeposit) ? null : Number(values.gdeposit),
          gearlyTerminationFee: !Boolean(values.gearlyTerminationFee)
            ? null
            : Number(values.gearlyTerminationFee),
          gadder: values.gadded === '' ? null : Number(values.gadded),
          grate: values.grate ? Number(values.grate) : null,
          gsecondRate: !Boolean(values.gsecondRate) ? null : Number(values.gsecondRate),
          gserviceFee: !Boolean(values.gserviceFee) ? null : Number(values.gserviceFee),
          gterm: values.gterm ? values.gterm : '',
          gunit: values.gunit ? values.gunit : '',
          gunitTypeId: values.gunitId,
          gutilityId: formik.getFieldMeta('gutilityId').value,
          gcontractTypeId: formik.getFieldMeta('gcontractTypeId').value || null,
          gcode: values.gcode ? values.gcode : '',
          gbillingMethod: values.gbillingMethod ? values.gbillingMethod : '',
          dynamicProductInput: {
            grateMaximum: values.grateMaximum ? Number(values.grateMaximum) : null,
            grateMinimum: values.grateMinimum ? Number(values.grateMinimum) : null,
            gtermMinimum: values.gtermMinimum ? values.gtermMinimum : '',
            gtermMaximum: values.gtermMaximum ? values.gtermMaximum : '',
          },
        }
      } else if (commodity === 'Dual') {
        formData = {
          ...formData,
          unitTypeId: formik.getFieldMeta('unitId').value || null,
          contractTypeId: formik.getFieldMeta('contractTypeId').value || null,
          deposit: !Boolean(values.deposit) ? null : Number(values.deposit),
          earlyTerminationFee: !Boolean(values.earlyTerminationFee)
            ? null
            : Number(values.earlyTerminationFee),
          adder: values.added === '' ? null : Number(values.added),
          rate: values.rate ? Number(values.rate) : null,
          secondRate: !Boolean(values.secondRate) ? null : Number(values.secondRate),
          serviceFee: !Boolean(values.serviceFee) ? null : Number(values.serviceFee),
          term: values.term ? values.term : '',
          unit: values.unit ? values.unit : '',
          utilityId: formik.getFieldMeta('utilityId').value,
          ecode: values.ecode ? values.ecode : '',
          ebillingMethod: values.ebillingMethod ? values.ebillingMethod : '',
          gdeposit: !Boolean(values.gdeposit) ? null : Number(values.gdeposit),
          gearlyTerminationFee: !Boolean(values.gearlyTerminationFee)
            ? null
            : Number(values.gearlyTerminationFee),
          gadder: values.gadded === '' ? null : Number(values.gadded),
          grate: values.grate ? Number(values.grate) : null,
          gsecondRate: !Boolean(values.gsecondRate) ? null : Number(values.gsecondRate),
          gserviceFee: !Boolean(values.gserviceFee) ? null : Number(values.gserviceFee),
          gterm: values.gterm ? values.gterm : '',
          gunit: values.gunit ? values.gunit : '',
          gunitTypeId: values.gunitId,
          gutilityId: formik.getFieldMeta('gutilityId').value,
          gcontractTypeId: formik.getFieldMeta('gcontractTypeId').value || null,
          gcode: values.gcode ? values.gcode : '',
          gbillingMethod: values.gbillingMethod ? values.gbillingMethod : '',
          ...(values.startDate
            ? { startDate: moment.utc(values.startDate).format() }
            : { startDate: null }),
          ...(values.endDate ? { endDate: moment.utc(values.endDate).format() } : { endDate: null }),
          dynamicProductInput: {
            grateMaximum: values.grateMaximum ? Number(values.grateMaximum) : null,
            grateMinimum: values.grateMinimum ? Number(values.grateMinimum) : null,
            gtermMinimum: values.gtermMinimum ? values.gtermMinimum : '',
            gtermMaximum: values.gtermMaximum ? values.gtermMaximum : '',
            rateMaximum: values.rateMaximum ? Number(values.rateMaximum) : null,
            rateMinimum: values.rateMinimum ? Number(values.rateMinimum) : null,
            termMinimum: values.termMinimum ? values.termMinimum : '',
            termMaximum: values.termMaximum ? values.termMaximum : '',
          },
        }
      }

      const LANGUAGE_ID_MAP: Record<LanguageType, string> = {
        English: Languages?.getAllLanguages?.filter((val: any) => val.languageName === 'English')?.[0]?.id,
        Spanish: Languages?.getAllLanguages?.filter((val: any) => val.languageName === 'Spanish')?.[0]?.id,
      };

      const POSITION_ID_MAP: Record<DocType, number> = {
        tmc: 0,
        dsc: 1,
        other: 2,
      };

      const backendDocKeys = new Map<string, any>();

      backendSmartDocs?.forEach((doc: any) => {
        const key = `${doc?.language?.languageName}-${doc?.smartDocId}-${doc?.position}`;

        backendDocKeys.set(key, {
          id: doc.id,
          productId: formik.getFieldMeta('id').value,
          languageId: doc.language.id,
          smartDocId: doc.smartDocId,
          position: doc.position,
        });
      });
      const selectedDocKeys = new Map<string, any>();
      Object.entries(selectedDocs).forEach(([language, docsByType]) => {
        Object.entries(docsByType).forEach(([docType, docs]) => {
          docs.forEach((doc) => {
            const key = `${language}-${doc.value}-${POSITION_ID_MAP[docType as DocType]}`;
            const backendDoc = backendDocKeys.get(key);
            selectedDocKeys.set(key, {
              ...(backendDoc?.id && { id: backendDoc.id ?? null }),
              productId: formik.getFieldMeta('id').value,
              languageId: LANGUAGE_ID_MAP[language as LanguageType],
              smartDocId: doc.value,
              position: POSITION_ID_MAP[docType as DocType],
            });
          });
        });
      });

      const deletedSmartDocs: any = [];
      backendDocKeys.forEach((backendDoc, key) => {
        if (!selectedDocKeys.has(key)) {
          deletedSmartDocs.push({
            ...backendDoc,
            isDeleted: true,
          });
        }
      });

      const smartDocProducts = [
        ...Array.from(selectedDocKeys.values()),
        ...deletedSmartDocs,
      ];


      if (method === 'Create' || method === 'clone') {
        let productFiles = []
        if (method === 'clone') {
          productFiles = getProductByIdData?.getProductById?.productFiles.map((data: any) => ({
            fileUrl: data.fileUrl,
            position: data.position,
          }))
        }

        if (method === 'Create') {
          for (const [language, docs] of Object.entries(documents)) {
            const languageId = LANGUAGE_ID_MAP[language as LanguageType];
            for (const [docType, file] of Object.entries(docs as any)) {
              if (!file) continue;
              const uploaded = await uploadFiles(
                [file],
                false,
                '',
                `Productfiles/${values.productName.replaceAll(' ', '-')}`
              );

              productFiles.push({
                languageId,
                fileUrl: uploaded[0],
                position: POSITION_ID[docType],
              });
            }
          }
        }

        await addProduct({
          variables: {
            createProductInput: {
              ...formData,
              ...(featureFlags?.getClientFeatureFlags?.isSmartDocEnabled && {
                smartDocProducts: smartDocProducts,
              }),
              notes: values.note1,
              scriptId: formik.getFieldMeta('scriptId').value,
              productFiles,
              ...{
                startDate: values.startDate
                  ? moment.utc(values.startDate).format()
                  : momentTimeZone().tz(momentTimeZone.tz.guess()).startOf('day').format(),
              },
            },
          },
        })
      }
      else if (method === 'edit') {
        const productFiles: any[] = []
        const backendFiles = getProductByIdData.getProductById?.productFiles || []

        // Get English language ID
        const englishLanguageId = LANGUAGE_ID_MAP['English']

        for (const [language, docs] of Object.entries(documents)) {
          const languageId = LANGUAGE_ID_MAP[language] ?? null

          for (const [docType, file] of Object.entries(docs as any)) {
            const position = POSITION_ID[docType]

            const existingFile = backendFiles.find((f: any) => {
              const normalizedBackendLangId =
                f.languageId ?? englishLanguageId

              return (
                normalizedBackendLangId === languageId &&
                f.position === position
              )
            })

            const existingUrl = existingFile?.fileUrl

            //  New file uploaded
            if (file && file instanceof File) {
              const uploaded = await uploadFiles(
                [file],
                false,
                '',
                `Productfiles/${values.productName.replaceAll(' ', '-')}`
              )

              productFiles.push({
                languageId: languageId ?? englishLanguageId,
                fileUrl: uploaded[0],
                position,
              })
            }

            // File removed
            else if (!file && existingUrl) {
              productFiles.push({
                languageId: languageId ?? englishLanguageId,
                fileUrl: '',
                position,
                isDelete: true,

              })
            }

          }
        }

        await updateProduct({
          variables: {
            updateProductInput: {
              ...formData,
              id: formik.getFieldMeta('id').value,
              productFiles,
              ...(featureFlags?.getClientFeatureFlags?.isSmartDocEnabled && {
                smartDocProducts,
              }),
              notes: values.note1,
              ...(formik.getFieldMeta('scriptId').value && {
                scriptId: formik.getFieldMeta('scriptId').value,
              }),
              ...(formik.getFieldMeta('prodScriptId').value && {
                prodScriptId: formik.getFieldMeta('prodScriptId').value,
              }),
            },
          },
        })
      }

    },
  })
  useEffect(() => {
    if (!formik.isSubmitting) {
      return
    }
    if (Object.keys(formik.errors).length > 0) {
      const errorElement = document.getElementById(Object.keys(formik.errors)[0])
      errorElement?.scrollIntoView({ behavior: 'smooth', block: 'center' })
      errorElement?.focus({ preventScroll: true })
    }
  }, [formik])

  const handleModalClose = () => {
    setCommodity('Electric')
    setDocuments({})
    setExpandedLang('English')
    handleClose()
    setEnglish([])
    setSpanish([])
    setBackendSmartDocs([]);
    setSelectedDocs({
      English: { tmc: [], dsc: [], other: [] },
      Spanish: { tmc: [], dsc: [], other: [] },
    })
  }
  console.log('selectedEnglish----', selectedDocs);
  const productTypeUtils = [
    {
      id: 'standard',
      value: 'Standard',
    },
    {
      id: 'dynamic',
      value: 'Dynamic',
    },
  ]
  const handleFileChange = (languageCode: string, type: string, file: File | null) => {
    setDocuments((prev: any) => ({
      ...prev,
      [languageCode]: {
        ...prev[languageCode],
        [type]: file,
      },
    }))
  }

  return createPortal(
    <Modal
      id='product-modal-id'
      tabIndex={-1}
      aria-hidden='true'
      dialogClassName='modal-dialog modal-dialog-scrollable modal-xl modal-fullscreen'
      show={show}
      onHide={() => handleModalClose()}
      backdrop={true}
    >
      <div className='modal-header'>
        <h2>{status} Product</h2>
        <div className='d-flex gap-5'>
          {featureFlags?.getClientFeatureFlags?.enableDynamicProductCreation && (
            <select
              id='brand'
              aria-label='select brand'
              className='form-select form-select-solid'
              disabled={status === 'Edit'}
              value={productType}
              onChange={(e) => {
                setProductType(e.target.value)
                formik.resetForm()
                formik.setErrors({})
                formik.setFieldValue('isDynamicProduct', e.target.value === 'Dynamic')
              }}
            >
              {productTypeUtils?.map(({ id, value }: any) => (
                <option value={value} key={id}>
                  {value}
                </option>
              ))}
            </select>
          )}
          <ToggleButton
            leftText='Inactive'
            rightText='Active'
            leftTextClassName='badge-light-danger'
            rightTextClassName='badge-light-success'
            isActive={activeStatus}
            onChange={(checked) => setActiveStatus(checked)}
          />
          <div
            className='btn btn-sm btn-icon btn-active-color-primary'
            onClick={() => handleModalClose()}
          >
            <SVG src={closeSymbol}></SVG>
          </div>
        </div>
      </div>
      <div className='hover-scroll-overlay-y mh-100% product-form'>
        {loading ? (
          <div className='text-center mh-400px'>
            <Spinner animation='border' className='text-gray-600 text-center' role='status'>
              <span className='visually-hidden'>Loading...</span>
            </Spinner>
          </div>
        ) : (
          <div className='mh-100% overflow-auto modal-body mx-10 ps-8 pe-2 py-0'>
            <Row className='d-flex align-items-start mt-5 no-gutters noPadding mb-5'>
              {/* Product Name */}
              <Col sm md lg={6}>
                <label className='d-flex align-items-center mb-2 required'>
                  <span className='fs-6 fw-semibold lh-23'>Product Name</span>
                </label>
                <input
                  type='text'
                  className='form-control form-control-lg form-control-solid'
                  placeholder='Enter product name'
                  id='productName'
                  maxLength={51}
                  {...formik.getFieldProps('productName')}
                />
                {formik.errors.productName && formik.touched.productName && (
                  <div className='fv-plugins-message-container'>
                    <div data-field='appname' data-validator='notEmpty' className='fv-help-block'>
                      {formik.errors.productName}
                    </div>
                  </div>
                )}
              </Col>
              {/* Brand */}
              <Col sm md lg={6}>
                <label className='d-flex align-items-center mb-2'>
                  <span className='fs-6 fw-semibold lh-23'>Brand</span>
                </label>
                <Dropdown
                  fieldName='brand'
                  optionList={brandData}
                  handleSelectedItem={handleSelectedItem}
                  formik={formik}
                />
              </Col>
            </Row>

            <Row className='d-flex align-items-start mt-5 no-gutters noPadding mb-5'>
              <Col sm md lg={6}>
                <label className='d-flex align-items-center mb-2'>
                  <span className='fs-6 fw-semibold lh-23'>Commodity</span>
                </label>
                <select
                  id='Commodity'
                  aria-label='select brand'
                  className='form-select form-select-solid'
                  value={commodity}
                  onChange={(e) => {
                    // console.log(e)
                    setCommodity(e.target.value)
                    formik.setFieldValue('commodity', e.target.value)
                    formik.setFieldValue(
                      'commodityId',
                      commodityData.filter((item: any) => item.value === e.target.value)[0]?.id
                    )
                  }}
                >
                  {commodityData?.map(({ id, value }: any) => (
                    <option value={value} key={id}>
                      {value}
                    </option>
                  ))}
                </select>
              </Col>
              <Col sm md lg={6}>
                <label className='d-flex align-items-center mb-2 required'>
                  <span className='fs-6 fw-semibold lh-23'>Customer Type</span>
                </label>
                <Dropdown
                  fieldName='customerType'
                  optionList={customerTypeData}
                  handleSelectedItem={handleSelectedItem}
                  formik={formik}
                />
              </Col>
            </Row>
            {(commodity === 'Electric' || commodity === 'Dual') && (
              <ElectricProperty
                utilityData={utilityData}
                handleSelectedItem={handleSelectedItem}
                formik={formik}
                contractTypeData={contractTypeData}
                restrictDecimal={restrictDecimal}
                preventScroll={preventScroll}
                unitData={unitData}
                isDynamicProducts={isDynamicProducts}
              />
            )}
            {(commodity === 'Gas' || commodity === 'Dual') && (
              <GasProperty
                utilityData={utilityData}
                handleSelectedItem={handleSelectedItem}
                formik={formik}
                contractTypeData={contractTypeData}
                restrictDecimal={restrictDecimal}
                preventScroll={preventScroll}
                unitData={unitData}
                isDynamicProducts={isDynamicProducts}
              />
            )}
            <Row className='d-flex align-items-start mt-5 no-gutters noPadding mb-5'>
              <Col sm md lg={6}>
                <label className='d-flex align-items-center mb-2'>
                  <span className='fs-6 fw-semibold lh-23'>Start Date</span>
                </label>
                <DatePicker
                  className='form-control form-control-solid ps-6'
                  id={'startDate'}
                  minDate={new Date()}
                  maxDate={formik.getFieldProps('endDate').value}
                  selected={formik.getFieldProps('startDate').value}
                  onChange={(val) => formik.setFieldValue('startDate', val)}
                  dateFormat='MM-dd-yyyy'
                  autoComplete='off'
                  placeholderText='MM-DD-YYYY'
                />
                {formik.errors.startDate && (
                  <div className='fv-plugins-message-container'>
                    <div data-field='appname' data-validator='notEmpty' className='fv-help-block'>
                      {formik.errors.startDate}
                    </div>
                  </div>
                )}
              </Col>
              <Col sm md lg={6}>
                <label className='d-flex align-items-center mb-2'>
                  <span className='fs-6 fw-semibold lh-23'>End Date</span>
                </label>
                <DatePicker
                  className='form-control form-control-solid ps-6'
                  id='endDate'
                  minDate={
                    formik.getFieldProps('startDate').value
                      ? new Date(
                        new Date(formik.getFieldProps('startDate').value).getTime() +
                        24 * 60 * 60 * 1000
                      )
                      : null
                  }
                  selected={formik.getFieldProps('endDate').value}
                  onChange={(val) => formik.setFieldValue('endDate', val)}
                  dateFormat='MM-dd-yyyy'
                  autoComplete='off'
                  placeholderText='MM-DD-YYYY'
                />

                {formik.errors.added && (
                  <div className='fv-plugins-message-container'>
                    <div data-field='appname' data-validator='notEmpty' className='fv-help-block'>
                      {formik.errors.endDate}
                    </div>
                  </div>
                )}
              </Col>
            </Row>
            <Row className='d-flex align-items-start mt-5 no-gutters noPadding mb-5'>
              <Col sm md lg={6}>
                <label className='d-flex align-items-center mb-2'>
                  <span className='fs-6 fw-semibold lh-23'>Assign to TPV Script</span>
                </label>
                <Dropdown
                  fieldName='script'
                  optionList={tpvScript}
                  handleSelectedItem={handleSelectedItem}
                  formik={formik}
                />
              </Col>
              {/* Unit */}
            </Row>
            <div>
              <label className='d-flex align-items-center mb-2'>
                <span className='fs-6 fw-semibold lh-23'>Additional Information</span>
              </label>
              <Row className='d-flex align-items-start mt-5 no-gutters noPadding mb-5'>
                <Col sm md lg={12}>
                  <Stack gap={4}>
                    {noteList.map((noteItem: any, index: number) => {
                      return (
                        <div key={index}>
                          <input
                            type='text'
                            id={noteItem.fieldName}
                            placeholder={noteItem.placeHolderText}
                            className='form-control form-control-solid'
                            {...formik.getFieldProps(noteItem.fieldName)}
                          />
                        </div>
                      )
                    })}
                  </Stack>
                </Col>
              </Row>
            </div>
            {(featureFlags?.getClientFeatureFlags?.enableSmsDocumentVerification ||
              featureFlags?.getClientFeatureFlags?.enableEmailDocumentVerification) && (
                <div className="d-flex flex-column gap-4">
                  {Languages?.getAllLanguages?.map((language: any) => {
                    const langCode = language.languageName;
                    const isOpen = expandedLang === langCode;
                    return (
                      <div key={language.id} className="border border-gray-300 rounded p-3 bg-light">
                        <div
                          className="d-flex justify-content-between align-items-center cursor-pointer"
                          onClick={() => toggleLanguage(langCode)}
                        >
                          <h5 className="mb-0">
                            {language.languageName} Documents
                          </h5>

                          <span className="fs-4">
                            {isOpen ? '−' : '+'}
                          </span>
                        </div>
                        {isOpen && (
                          <Row className="mt-4 g-4">
                            <Col lg={4}>
                              <label className="fw-semibold mb-2">Terms and Conditions</label>
                              {documents?.[langCode]?.TC ? (
                                <PdfPreview
                                  url={documents[langCode].TC}
                                  isViewable
                                  removeFile={() =>
                                    handleFileChange(langCode, "TC", null)
                                  }
                                />
                              ) : (
                                <DragDrop
                                  fileTypes={fileUploadFileType}
                                  setFile={(file: File) =>
                                    handleFileChange(langCode, "TC", file)
                                  }
                                  label="Upload Terms and Conditions"
                                />
                              )}
                            </Col>
                            <Col lg={4}>
                              <label className="fw-semibold mb-2">Disclosure Statement</label>
                              {documents?.[langCode]?.DSC ? (
                                <PdfPreview
                                  url={documents[langCode].DSC}
                                  isViewable
                                  removeFile={() =>
                                    handleFileChange(langCode, "DSC", null)
                                  }
                                />
                              ) : (
                                <DragDrop
                                  fileTypes={fileUploadFileType}
                                  setFile={(file: File) =>
                                    handleFileChange(langCode, "DSC", file)
                                  }
                                  label="Upload Disclosure Statement"
                                />
                              )}
                            </Col>
                            <Col lg={4}>
                              <label className="fw-semibold mb-2">Other</label>
                              {documents?.[langCode]?.OTHER ? (
                                <PdfPreview
                                  url={documents[langCode].OTHER}
                                  isViewable
                                  removeFile={() =>
                                    handleFileChange(langCode, "OTHER", null)
                                  }
                                />
                              ) : (
                                <DragDrop
                                  fileTypes={fileUploadFileType}
                                  setFile={(file: File) =>
                                    handleFileChange(langCode, "OTHER", file)
                                  }
                                  label="Upload Other"
                                />
                              )}
                            </Col>
                          </Row>
                        )}
                      </div>
                    );
                  })}
                </div>
              )}
            {featureFlags?.getClientFeatureFlags?.isSmartDocEnabled && (featureFlags?.getClientFeatureFlags?.enableSmsDocumentVerification ||
              featureFlags?.getClientFeatureFlags?.enableEmailDocumentVerification) && <>
                <AssingedSmartDocsSection formik={formik} handleSelectedItem={handleSelectedItem} setSelectedDocs={setSelectedDocs} selectedDocs={selectedDocs} setEnglish={setEnglish} setSpanish={setSpanish} selectedSpanish={selectedSpanish} selectedEnglish={selectedEnglish} />
              </>}
          </div>
        )}

        <div
          className='modal-footer sticky-bottom bg-white'
          style={{ borderRadius: '0 0 20px 20px', zIndex: '2' }}
        >
          <button type='button' className='btn btn-light' onClick={() => handleModalClose()}>
            Discard
          </button>
          <button
            className={'btn btn-primary'}
            data-kt-stepper-action='submit'
            onClick={(e) => formik.submitForm()}
          >
            {submitting
              ? method === 'Create'
                ? 'Creating product'
                : 'Updating product'
              : 'Submit'}
            {submitting && (
              <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
            )}
          </button>
        </div>
      </div>
    </Modal>,
    modalsRoot
  );
}

export { AddProductModal }
